'use client';

import React from 'react';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import Container from '@mui/material/Container';
import Footer from '@/components/footer';
import Header from './Header';
import DashboardFooter from '@/components/layout-new/Footer';
import DashboardNav from '@/components/layout-new/dashboard/DashboardNav';
import { AuthContext } from '@/context/create-context';
import { RESUME_DASHBOARD_NAV_ID } from '@/constants/component-id';

gsap.registerPlugin(useGSAP);

const Main = (props: {
  children: React.ReactNode;
  isHideHeader?: boolean;
  outContainerEle?: React.ReactElement;
  isSalaryLink?: boolean;
}) => {
  const {
    children,
    isHideHeader,
    outContainerEle,
    isSalaryLink = true,
  } = props;
  const { user } = React.useContext(AuthContext);

  const isLogin = React.useMemo(
    () => !!(user && user.is_authenticated),
    [user?.is_authenticated],
  );

  useGSAP(() => {
    if (isHideHeader && isLogin) {
      gsap.set(`#${RESUME_DASHBOARD_NAV_ID}`, { display: 'block' });
      gsap.from(`#${RESUME_DASHBOARD_NAV_ID}`, {
        opacity: 0,
        duration: 0.3,
        ease: 'power1.inOut',
      });
    }
  }, [isLogin]);

  return (
    <>
      <div className={isLogin ? 'flex pt-12' : 'pt-16'}>
        {!isLogin && <Header isHideHeader={isHideHeader} />}
        {isLogin ? (
          <DashboardNav
            isSalaryLink={isSalaryLink}
            isHideHeader={isHideHeader}
          />
        ) : (
          outContainerEle
        )}
        <main
          className={
            isLogin
              ? 'min-h-[calc(100vh-22px)] w-full pb-7'
              : 'min-h-screen w-full pb-7'
          }
        >
          {isLogin && outContainerEle}
          <Container
            className={isLogin ? '' : '!min-h-screen !mt-3.5 tablet:!mt-1'}
            maxWidth="desktop"
          >
            {children}
          </Container>
        </main>
      </div>
      {isLogin ? <DashboardFooter /> : <Footer />}
    </>
  );
};

export default Main;
